import { urlCertification } from "./urls" 

export const messagesAddCertification = { 
    type : 'addCertification',
    url : urlCertification,
    messageTextsOK : {
        messageTitle : 'Certificacion guardada con éxito',
        buttonLeft : 'Volver a certificaciones',
        buttonRight: 'Continuar para imprimir'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : '',
        buttonRight: 'Volver a certificaciones'
    }
}
export const messagesEditCertification = { 
    type : 'addCertification',
    url : urlCertification,
    messageTextsOK : {
        messageTitle : 'Certificacion editada con éxito',
        buttonLeft : 'Volver a certificaciones',
        buttonRight: 'Continuar para imprimir'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        buttonLeft : '',
        buttonRight: 'Volver a certificaciones'
    }
}